import { Allotment } from 'allotment';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { DefaultButton } from './DefaultButton';
import { useResizeContext } from './ResizeablePanel';
import PropTypes from 'prop-types';
import { Col, Row } from './Grid';
import { GuideButton } from './GuideButton';
import ConfigStatusButton from './ConfigStatusButton';

const SettingsContext = createContext({});

export const useSettingsContext = () => {
    return useContext(SettingsContext);
}

export const SettingsDisplay = ({ title, guide, uuid, cutPoint, controls, children, onClose, maxSizes, ...props }) => {
    const DEFAULT_CUT_POINT = 1000;
    const [selections, setSelections] = useState([{ index: 0, callback: onClose }]);
    const { width } = useResizeContext();
    const isWide = width > (cutPoint ?? DEFAULT_CUT_POINT);
    const active = selections[selections.length - 1];
    
    const pushPanel = useCallback((index, callback, title) => {
        if (active.index !== index) {
            setSelections(selections => [...selections, {index, title, callback}]);
        }
    }, [active]);

    const popPanel = useCallback(() => {
        active?.callback?.();
        setSelections(selections => {
            if (selections.length > 1) {
                return selections.slice(0, -1);
            } else {
                return selections;
            }
        });
    }, [active]);       

    const clearPanels = useCallback(() => {
        setSelections([{ index: 0, callback: onClose }]);
    }, [onClose]);
    const context = useMemo(() => ({ pushPanel, popPanel, clearPanels }), [pushPanel, popPanel, clearPanels]);
    

    return <div className="w-100 h-100" style={{ display: 'flex', flexDirection: 'column'}}>
        <SettingsContext.Provider value={context}>
            { title || (!isWide && onClose) ? <div className="py-2 mx-2" style={{ position: 'sticky', top: '0px', backgroundColor: 'white', zIndex: 10 }}>
                <Row>
                    <Col className="pr-2" md="auto">
                        <Row>
                            <Col xs="auto"><h4>{(active?.title) ?? title}</h4></Col>
                            <Col className="mx-1" xs="auto">
                            <GuideButton guide={guide}></GuideButton>
                            </Col>
                            <Col className="mx-1" xs="auto">
                                { uuid && <ConfigStatusButton uuid={uuid}></ConfigStatusButton> }
                            </Col>
                        </Row>
                        
                    </Col>
                    <Col md>{controls}</Col>
                    <Col md="auto" className="text-end mr-2">
                        { active.index > 0 || (!isWide && onClose) ? <DefaultButton kind="close" onClick={popPanel}></DefaultButton> : null }
                    </Col>
                </Row>
            </div> : null }
            <Allotment snap={true} style={{ flex: 1 }} {...props}>
                { Array.isArray(children) ? children.map((c, i) => {
                    if (isWide || i === active.index) {
                        return <Allotment.Pane maxSize={isWide ? maxSizes?.[i] : Infinity}>
                            <div  id="adminSettingsPanel" className="h-100 w-100 ">
                                {c}
                            </div>
                        </Allotment.Pane>
                    }
                    return null;
                }) : children }
            </Allotment>
        </SettingsContext.Provider>
    </div>
}

SettingsDisplay.propTypes = {
    title: PropTypes.string,
    guide: PropTypes.number,
    uuid: PropTypes.string,
    cutPoint: PropTypes.number,
    controls: PropTypes.array,
    titles: PropTypes.array,
    constrols: PropTypes.node,
    onClose: PropTypes.func,
    children: PropTypes.node,
    maxSizes: PropTypes.array
}